<template>
    <tbody>
    <tr>
        <td><i class="fas fa-grip-vertical"></i></td>
        <td width="15%">
            <div class="form-control p-0-0">
                <goods-services-select :expressid="expressid"
                                       @good-services-select="setGoodsSerivces"
                                       data-vv-as="goodsSerivces"
                                       id="goodsSerivces"
                                       name="goodsSerivces"
                                       ref="goodsSerivces"
                                       style="width: 200px; height: 42px;"
                                       v-model="lineitem.goodsSerivces.id"
                                       v-validate="'required'">
                </goods-services-select>
            </div>
        </td>
        <td width="15%">
            <textarea :name="'description'+index"
                      class="form-control"
                      v-model="lineitem.description"
                      placeholder="Description"
                      style="height: 42px;"
                      cols="30">
            </textarea>
        </td>
        <td>
            <multiselect class="form-control"
                         :name="'category'+index"
                         v-model="lineitem.expense_category"
                         :options="categoryOptions"
                         :multiple="false"
                         group-values="accounts"
                         group-label="group"
                         :group-select="true"
                         placeholder="Select Category"
                         track-by="name"
                         label="name">
                <span slot="noResult">Oops! No elements found. Consider changing the search query.</span>
            </multiselect>
        </td>
        <td width="15%">
            <div class="input-group">
                <input class="form-control"
                       data-vv-as="Name"
                       :id="'quantity'+index"
                       name="quantity"
                       placeholder="Quantity"
                       style="height: 42px;"
                       type="text"
                       v-model="lineitem.quantity"
                       v-on:keyup="quantityAndRateChange"
                       v-validate="'required'">
                <div class="input-group-append">
                    <span class="input-group-text">{{lineitem.unitSymbol}}</span>
                </div>
            </div>
        </td>
        <td width="12%">
            <input class="form-control"
                   data-vv-as="rate"
                   :id="'rate'+index"
                   name="rate"
                   placeholder="Rate"
                   style="height: 42px;"
                   type="text"
                   v-model="lineitem.rate"
                   v-on:keyup="quantityAndRateChange"
                   v-validate="'required'">
        </td>
        <td class="text-right">
            <h5 class="m-b-0" v-if="lineitem.amount">{{lineitem.amount | money}}</h5>
        </td>
        <td class="icon-col">
            <i class="far fa-trash-alt"></i>
        </td>
    </tr>

    <!-- Taxes-->

    <tr>
        <td class="tax" colspan="4">
            Tax
        </td>
        <td colspan="2">
            <multiselect :id="'tax'+index"
                         class="form-control"
                         deselect-label="Can't remove this value"
                         track-by="rateid"
                         label="name"
                         placeholder="Select Tax"
                         open-direction="bottom"
                         v-model="tax"
                         @input="addTax"
                         :max-height="300"
                         :options-limit="300"
                         :options="taxOptions"
                         :searchable="true"
                         :allow-empty="false">
                <template slot="singleLabel" slot-scope="props">
                    <span class="option__desc">
                        <span class="option__title">{{ props.option.description }} &nbsp;&nbsp; {{ props.option.rate }}%</span>
                    </span>
                </template>
                <template slot="option" slot-scope="props">
                    <span class="option__title"><b>{{ props.option.name }}</b> &nbsp;&nbsp; {{ props.option.rate }}%</span>
                </template>
            </multiselect>
        </td>
        <td class="text-right">
        </td>
    </tr>

    <tr v-if="lineitem.taxes.length > 0" v-for="(t, tindex) in lineitem.taxes">
        <td class="tax" colspan="4">
        </td>
        <td colspan="2">
            {{t.name}} - {{t.rate}}%
        </td>
        <td class="text-right">
            {{t.value.amount}}
        </td>
        <td class="icon-col">
            <i class="far fa-trash-alt"></i>
        </td>
    </tr>

    </tbody>
</template>

<script>
    import _ from 'lodash';
    import {mapGetters} from "vuex";
    import Multiselect from 'vue-multiselect';
    import {BigNumber} from "bignumber.js";
    import GoodsServicesSelect from "../../../protected/common/GoodsServicesSelect";

    export default {
        name: "BillLineItem",
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        props: {
            lineitem: Object,
            currency: Object,
            index: Number,
            expressid: Number
        },
        components: {Multiselect, GoodsServicesSelect},
        data() {
            return {
                isLoading: false,
                tax: null,
                category: null,
                taxOptions: [],
                categoryOptions: []
            };
        },
        mounted() {
            this.getTaxes();
            this.getExpenseCategories();
        },
        methods: {
            setGoodsSerivces(gs) {
                this.lineitem.goodsSerivces = gs;
                this.lineitem.unitSymbol    = gs.unit_symbol;
            },
            async getTaxes() {
                this.isLoading = true;

                let reply  = await this.$http.get(`org/${this.currentOrg.id}/taxes`);
                let groups = reply.data;

                _.forEach(groups, group => {
                    _.forEach(group.rates, rate => {
                        let tax = {
                            name: group.name,
                            description: group.description,
                            rateid: rate.id,
                            rate: rate.value
                        };
                        this.taxOptions.push(tax);
                    });
                });

                this.isLoading = false;
            },
            async getExpenseCategories() {
                this.isLoading = true;

                let reply            = await this.$http.get(`org/${this.currentOrg.id}/chart_of_account`);
                this.categoryOptions = reply.data;

                this.isLoading = false;
            },
            addTax(tax) {
                this.lineitem.taxes.push({
                    name: tax.name,
                    rate_id: tax.rateid,
                    rate: tax.rate,
                    value: {
                        amount: Number(this.lineitem.amount.amount) * Number(tax.rate) / 100,
                        currency_id: this.currency.id,
                        currency_name: this.currency.name,
                        currency_symbol: this.currency.symbol
                    }
                });
                this.tax = null;
            },
            addCategory(category) {
                this.category                  = category;
                this.lineitem.expense_category = category;
            },
            quantityAndRateChange() {
                let ini_amount       = Number(this.lineitem.rate) * Number(this.lineitem.quantity);
                this.lineitem.amount = {
                    amount: ini_amount,
                    currency_id: this.currency.id,
                    currency_name: this.currency.name,
                    currency_symbol: this.currency.symbol
                };
            },
            calculateTax(tax) {
                if(!tax || !tax.rate) {
                    return "-";
                }

                this.$emit('calculateTaxSubTotal');

                return new BigNumber(this.lineitem.quantity)
                .multipliedBy(new BigNumber(this.lineitem.rate))
                .multipliedBy(new BigNumber(tax.rate).div(100))
                .toFormat(2);
            }
        }
    }
</script>

<style scoped>
    table th, .table td {
        padding: 1rem;
        vertical-align: top;
        border-top: 0;
    }

    table td {
        text-align: left;
        vertical-align: top;
    }

    table td.tax {
        text-align: right;
        vertical-align: middle;
    }
</style>
